var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 36,
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 35.904,
    rx: 17.952,
    width: 35.904
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.005 11.717a8.376 8.376 0 01-2.37.65 4.144 4.144 0 001.821-2.284 8.269 8.269 0 01-2.623 1 4.127 4.127 0 00-7.029 3.764 11.734 11.734 0 01-8.511-4.287 4.127 4.127 0 001.267 5.491 4.131 4.131 0 01-1.871-.515v.055A4.127 4.127 0 0012 19.633a4.203 4.203 0 01-1.862.072 4.123 4.123 0 003.852 2.864 8.279 8.279 0 01-6.104 1.698 11.638 11.638 0 006.336 1.854c7.603 0 11.739-6.285 11.739-11.734v-.537a8.372 8.372 0 002.044-2.133z",
    fill: "#88456e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e147ecd70bce08c381d3d2f2146b10f8.svg";
export { ForwardRef as ReactComponent };